<template>
    <div class="medical-records product-section custom-section">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="bg-white border-radius-5 p-4">
                    <div class="card border-0 p-0">
                        <div class="card-body p-0">
                            <div class="row no-gutters Vitamins">
                                <div class="col-md-12">
                                    <h2 class="mb-3">Custom Vitamins</h2>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-md-6 pr-3">
                                    <figure class="border-radius-5 text-center d-flex justify-content-center align-items-center p-5 bg-body mb-0">
                                        <img src="../../../../../static/website/images/shelcal-image.png" alt="" />
                                    </figure>
                                </div>
                                <div class="col-md-6 pl-3 pr-5">
                                    <h3 class="mb-0">Gini Supplements</h3>
                                    <p class="mb-2">A multivitamin made just for you. Vegan. Personalized. Bio Available. Gluten Free. No harmful & artificial fillers. Get ready to feel the new you.</p>
                                    <div class="price d-flex justify-content-between align-items-center">
                                        <div class="text-left">
                                            <h3 class="mb-0"><span>$45.00</span> every 30 days</h3>
                                            <p><span>$35.00</span> with promo code <span>GINIFIRST</span></p>
                                        </div>
                                    </div>
                                    <div class="rating d-flex justify-content-between align-items-center">
                                        <h4>RATING</h4>
                                        <ul class="d-flex">
                                            <li>
                                                <a href="#"><i class="icon icon-star"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i class="icon icon-star"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i class="icon icon-star"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i class="icon icon-star"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i class="icon icon-star"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                    <h6 class="mb-3">Note: Supplements are shipped every 60 days. The shipment contains enough pills to cover those 60 days. We collect payment every 30 days to help our customers budget.</h6>
                                    <router-link to="/cart-suppliment" class="btn btn-blue Buy-Now">Buy Now</router-link>
                                </div>
                            </div>
                            <div class="row no-gutters mt-4 customised-product pt-2">
                                <div class="col-md-12">
                                    <h2 class="mb-4">Your supplements are customised to the following:</h2>
                                    <ul class="mb-3 d-flex splyMent flex-wrap">
                                        <li class="mr-5"><img src="../../../../../static/website/images/customised.svg" alt="" class="mr-3" /> <span>Bio</span></li>
                                        <li class="mr-5"><img src="../../../../../static/website/images/customised.svg" alt="" class="mr-3" /> <span>Diet</span></li>
                                        <li class="mr-5"><img src="../../../../../static/website/images/customised.svg" alt="" class="mr-3" /> <span> Health Goals</span></li>
                                        <li class="mr-5"><img src="../../../../../static/website/images/customised.svg" alt="" class="mr-3" /> <span>General Health</span></li>
                                        <li class="mr-5"><img src="../../../../../static/website/images/customised.svg" alt="" class="mr-3" /> <span>Deficiencies</span></li>
                                        <li class="mr-5"><img src="../../../../../static/website/images/customised.svg" alt="" class="mr-3" /> <span>Lifestyle</span></li>
                                    </ul>
                                    <p>You can chaznge your answers from the quiz to personalize your ingredient dosages.</p>
                                </div>
                                <div class="col-md-12 d-flex justify-content-between align-items-center mt-4 Vitamins-area flex-wrap">
                                    <div class="text-left">
                                        <h2 class="mb-2">Vitamins</h2>
                                        <p>Select "Learn More" to adjust the ingredient's recommended dosage.</p>
                                    </div>
                                    <a href="#" class="btn btn-blue answer">Change your answer</a>
                                </div>
                            </div>
                            <div class="row vitamin-product pt-2">
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Vitamin A</h4>
                                            <p class="mb-0">For your vegetarian diet</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">7000 IU</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li class="mr-3"><img src="../../../../../static/website/images/vitamin-heart.svg" /></li>
                                                <li><img src="../../../../../static/website/images/vitamin-en.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">B12</h4>
                                            <p class="mb-0">For your energy goal</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">5mg</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li><img src="../../../../../static/website/images/vitamin-en.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Folate</h4>
                                            <p class="mb-0">For your depression</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">200mcg</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li class="mr-3"><img src="../../../../../static/website/images/vitamin-bone.svg" /></li>
                                                <li><img src="../../../../../static/website/images/vitamin-mind.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Vitamin D3</h4>
                                            <p class="mb-0">For your depression</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">800 IU</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li class="mr-3"><img src="../../../../../static/website/images/vitamin-bone.svg" /></li>
                                                <li><img src="../../../../../static/website/images/vitamin-mind.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Iron</h4>
                                            <p class="mb-0">For your vegetarian diet</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">5mg</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li><img src="../../../../../static/website/images/vitamin-heart.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Zinc</h4>
                                            <p class="mb-0">For your Vegetarian diet</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">5mg</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li><img src="../../../../../static/website/images/shield.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Vitamin A</h4>
                                            <p class="mb-0">For your vegetarian diet</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">7000 IU</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li class="mr-3"><img src="../../../../../static/website/images/vitamin-heart.svg" /></li>
                                                <li><img src="../../../../../static/website/images/vitamin-en.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">B12</h4>
                                            <p class="mb-0">For your energy goal</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">5mg</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li><img src="../../../../../static/website/images/vitamin-en.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Folate</h4>
                                            <p class="mb-0">For your depression</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">200mcg</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li class="mr-3"><img src="../../../../../static/website/images/vitamin-bone.svg" /></li>
                                                <li><img src="../../../../../static/website/images/vitamin-mind.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Vitamin D3</h4>
                                            <p class="mb-0">For your depression</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">800 IU</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li class="mr-3"><img src="../../../../../static/website/images/vitamin-bone.svg" /></li>
                                                <li><img src="../../../../../static/website/images/vitamin-mind.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Iron</h4>
                                            <p class="mb-0">For your vegetarian diet</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">5mg</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li><img src="../../../../../static/website/images/vitamin-heart.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="bg-body border-radius-5 p-3 d-flex justify-content-between">
                                        <div class="text-left">
                                            <h4 class="mb-0">Zinc</h4>
                                            <p class="mb-0">For your Vegetarian diet</p>
                                        </div>
                                        <div class="text-right">
                                            <h5 class="mb-0">5mg</h5>
                                            <ul class="mb-0 d-flex justify-content-end">
                                                <li><img src="../../../../../static/website/images/shield.svg" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Nutrition",
        data() {
            return {};
        },
        created() {
            this.pageName("Nutrition and Supplements");
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/website/nutrition/pages/custom-suppliment-detail.vue